module.exports = __webpack_public_path__ + "6bc2c17/img/path.6583e684.svg";